import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { useContext, useEffect, useState, Context as ReactContext } from 'react';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { SubscriberRecord } from '../../Common/ConsumerModels/SubscriberRecord';

export function useGetConsumersForHome() {
  const [consumerList, setConsumerList] = useState<SubscriberRecord[]>([]);
  const [consumerListLoading, setConsumerListLoading] = useState<boolean>(true);
  const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);

  useEffect(() => {
    setConsumerListLoading(true);
    httpClient
      .get<SubscriberRecord[]>(`${__API_BASE_URL__}/subscriber/getAllSubscribers`, {
        resource: __CLIENT_ID__,
        headers: {
          'Content-Type': 'application/json',
          'X-Content-Type-Options': 'nosniff',
        },
      })
      .then(({ data }) => {
        // Limit to Three Consumers shown on the Home Page
        const newConsumerList = (data as SubscriberRecord[]).slice(0, 3);
        setConsumerList(newConsumerList);
        setConsumerListLoading(false);
      });
  }, []);

  return [consumerList, consumerListLoading] as const;
}
